export default {
  getDiscountList: (_state: any) => _state.financialInformation.discount,
  getPaymentList: (_state: any) => _state.financialInformation.payment
};
